/* eslint-disable */
import React, {useState} from 'react';
//css
import 'contents/assets/scss/page/teacher.scss';
//component
import Tab from '../../component/Inc/Tab';
import PopBrochureList from './_PopBrochureList';

//image
function BrochureStock() {
  const [tabIdx, setTabIdx] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const tab = [
    {title: '인쇄 책자', value: 0},
    {title: '국어', value: 1}
  ];

  return (
    <main className="com_container p_brochure_stock">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu3_12">홍보책자 재고관리</h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalOpen(true)} className="com_btn orange s btn_settings">
              홍보책자 목록 관리
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <div className="com_board_form">
                <select name="" id="" className="select">
                  <option value="">연도 선택</option>
                </select>
                <span className="com_btn lightRed s">재고 부족(4)</span>
              </div>
              <section className="com_board_search">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="60" />
                  <col width="140" />
                  <col width="140" />
                  <col width="auto" />
                  <col width="140" />
                  <col width="140" />
                </colgroup>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>영역</th>
                    <th>비고</th>
                    <th>홍보 책자 명</th>
                    <th>최근</th>
                    <th>재고</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="selected">
                    <td>1</td>
                    <td>과탐</td>
                    <td>
                      <button className="btn_link">과탐</button>
                    </td>
                    <td>수학02 단단히 추려낸 단어집</td>
                    <td className="com_red_txt">-0.5</td>
                    <td className="com_blue_txt">456</td>
                  </tr>
                  {Array.from({length: 30}).map((i, idx) => {
                    return (
                      <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td>과탐</td>
                        <td>
                          <button className="btn_link">과탐</button>
                        </td>
                        <td>수학02 단단히 추려낸 단어집</td>
                        <td className="com_red_txt">-0.5</td>
                        <td className="com_blue_txt">456</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </section>

          <section className="box">
            <div className="com_board_box">
              <h2 className="detail_tit dot">상세보기 </h2>
              <div className="com_board_list__top">
                <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
                <button className="com_btn black s btn_settings_bk">관리</button>
              </div>
              <h3 className="detail_tit_dk">2023 이지수능교육 핵심 홍보책자</h3>
              <div className="board_item">
                <div className="info center">
                  <div className="com_input_upload">
                    <p className="file">
                      <span className="txt">File name.pdf</span>
                      <button type="button" className="btn_del_file" onClick={() => {}}></button>
                    </p>
                  </div>
                  <div className="right_item">
                    <button type="button" className="btn_down" onClick={() => {}}></button>
                  </div>
                </div>
                <div className="info center">
                  <div className="com_input_upload">
                    <p className="file">
                      <span className="txt">File name.pdf</span>
                      <button type="button" className="btn_del_file" onClick={() => {}}></button>
                    </p>
                  </div>
                  <div className="right_item">
                    <button type="button" className="btn_down" onClick={() => {}}></button>
                  </div>
                </div>
              </div>
              <div className="com_board_list__scroll right_table">
                <table className="com_board_list">
                  <colgroup>
                    <col width="40" />
                    <col width="auto" />
                    <col width="90" />
                    <col width="90" />
                    <col width="90" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>요청일</th>
                      <th>입출고 자</th>
                      <th>입출 권 수</th>
                      <th>재고</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="selected">
                      <td>1</td>
                      <td>2022, 08, 25 18:30</td>
                      <td>
                        <button className="btn_link">가길동201</button>
                      </td>
                      <td className="com_red_txt">-45</td>
                      <td className="com_red_txt">400</td>
                    </tr>
                    {Array.from({length: 15}).map((i, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>2022, 08, 25 18:30</td>
                          <td>
                            <button className="btn_link">가길동201</button>
                          </td>
                          <td className="com_blue_txt">+45</td>
                          <td className="com_blue_txt">400</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">김입고103 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                  <div className="btn_wrap">
                    <button className="btn_edit"></button>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info center">
                  <div className="check">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">입고</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">출고</label>
                  </div>
                  <div className="right_item">
                    <div className="com_board_form">
                      권수입력 <input type="text" className="input ws" defaultValue={1225000} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange xs">등록</button>
            </div>
          </section>
        </section>
      </div>
      <PopBrochureList open={modalOpen} close={() => setModalOpen(false)} />
    </main>
  );
}

export default BrochureStock;
